export const Privileges = Object.freeze({
  PATIENTS: "patients",
  ADMIN: "admin",
  LOCATIONS: "locations",
  USERS: "users",
  PRAC_GROUPS: "pracGroups",
  DASHBOARD: "dashboard",
  REPORTS: "reports",
  PROF_SETTINGS: "profSettings",
  ROLE_ACCESS: "roleAccess",
  SURVEY: "survey",
  ORDERS: "orders",
  SIGN_ORDER: "signOrder",
  INSURANCES: "insurances",
  SCHEDULE: "schedule",
  INSURANCE_VERIFICATION: "insuranceVerification",
  AUTHORIZATION: "authorization",
  UPLOAD_RESULTS: "uploadResults",
  REVIEW_RESULTS: "reviewResults",
  ALL_PATIENTS: "allPatients",
  COMPLETE_STUDY: "completeStudy",
  FOLLOWUP: "followup",
  DOCUMENTS: "documents",
  SCORING: "scoring",
  COMPLIANCE_REPORT: "complianceReport",
  REVIEW_FORMS: "reviewForms",
  CONFIRM_STUDY: "confirmStudy",
  DISCUSS_RESULTS: "discussResults",
  ENCRYPTED_INFO: "encryptedInfo",
  VIEW_ENCRYPTED_INFO: "viewEncryptedInfo",
  REFERRAL: "referral",
  ORDER_AUTHORITY: "orderAuthority",
  TECH_SCHEDULING: "techScheduling",
  DME_SETUP: "dmeSetup",
  SLEEP_TECH: "sleepTech",
  REVIEW_COMPLIANCE: "reviewCompliance",
  F2F_EVALUATION: "F2Fevaluation",
  RECOVER_DEVICE: "recoverDevice",
  INTERPRET_STUDY: "interpretStudy",
  REVIEW_AUTH_DENIAL_ORDER: "reviewAuthDenialOrder",
});
